module.exports = __webpack_public_path__ + "static/media/18.011.d95b1dd8.jpg";